import React from 'react';
import { OrderList } from 'customer';

export class Orders extends React.Component {
    render() {
        return (
            <div className="page-content-customer">
                <OrderList {...this.props} />
            </div>
        );
    }
}
